import React from 'react';

import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';

import Heading from '../Heading';
import Description from '../Description';
import IconCard from '../IconCard';

import './index.scss';

/*
  size = {small, medium, large}
*/
const BMESlider = ({ sliderItems }) => {

	return ( 
			<div className="bme-slider-wrap">
                <div className="bme-slider">
                    <Carousel autoPlay infiniteLoop	interval={2000} centerMode
                              centerSlidePercentage={20} selectedItem={5}
                              showIndicators={false} showStatus={false} showArrows={false}>
                        {
                            sliderItems.map(item => {
                                return (
                                    <React.Fragment key={item}>
                                        <IconCard size="medium" shadow={true} bgGray={false} icon={item.icon} />
                                        <div className="description">
                                            <p className="description-title">{item.name} </p>
                                            <p className="description-txt">{item.shortDescription}</p>
                                        </div>
                                    </React.Fragment>
                                );
                            })
                        }
                    </Carousel>
                </div>
            </div>
    );
  };

export default BMESlider;
